import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VLayout,{attrs:{"p-0":""}},[_c(VFlex,{attrs:{"xs12":"","sm12":"","md6":"","sm6":""}},[_c(VImg,{attrs:{"src":_vm.contactImage,"height":"200px"}}),_c('input',{staticClass:"inputfile",attrs:{"type":"file","id":"embedpollfileinput"},on:{"change":_vm.getFile}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }